import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import MainLayout from "../../../components/layouts/MainLayout";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";

import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

//global distructures
const { Text, Link, Title } = Typography;
const Search = Input;
const { manageSalesTransactionItems, monthList } = staticConfig;

const columns = [
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
  },
  {
    title: "Account No",
    dataIndex: "accountNo",
  },
  {
    title: "Account Holder",
    dataIndex: "accountHolder",
  },
  {
    title: "Transaction Ref.",
    dataIndex: "transactionRef",
  },
  {
    title: "Currency",
    dataIndex: "currency",
  },
  {
    title: "Transaction Amount",
    dataIndex: "amount",
  },
];

const ManageCashDeposit = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [cashDepositList, setCashDepositList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setCashDepositList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.accountNo?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setCashDepositList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    rightAction(cnt.RIGHT_ADD_BTN);

    getCashDeposit();
  }, []);

  const getCashDeposit = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      apiConfig.savingsAccountsTransactions,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          setIsLoading(false);
        } else {
          const objList = res;
          const deposit = objList.filter((txn) =>
            txn.transactionType?.value?.toLowerCase().includes("deposit")
          );
          
          console.log(deposit)

          let tempArray = [];

          deposit.forEach((element, index) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              transactionDate: element?.submittedOnDate
                ? BOM.FormatArrayDate(element?.submittedOnDate)
                : "-",
              accountNo: element?.accountNo ? element?.accountNo : "-",
              accountHolder: element?.submittedByUsername
                ? element?.submittedByUsername
                : "-",
              transactionRef: element?.id ? element?.id : "-",
              currency: element.currency.displayLabel
                ? element.currency.displayLabel
                : "-",
              amount: element.amount ? Number(element.amount).toLocaleString()  : "-",
            });
          });

          setCashDepositList(tempArray);

          //keep the orginal data to use after gList is modified when change from autorise to disable
          setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-tlo0800", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-tlo0800", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
  //   [cnt.RIGHT_DETAIL_BTN].map((item) => {
  //     dispatch({
  //       type: item,
  //     });
  //   }
  // );
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
    >
      <TopContent
        pageTitle={labelConfig.manageCashDeposit}
        pageItems={staticConfig.manageCashDepositItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"Cash Deposits"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Account No..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={cashDepositList}
              columns={columns}
              fileName={"Cash Deposit List"}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={cashDepositList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageCashDeposit);
